(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.announcement-bar').forEach(function (bar) {
    var autorotateSeconds = parseInt(bar.dataset.autorotate, 10) || 0;
    var messages = Array.from(bar.querySelectorAll('.announcement-bar__message'));
    var btnPrev = bar.querySelector('.announcement-bar__nav--prev');
    var btnNext = bar.querySelector('.announcement-bar__nav--next');
    var current = 0;
    var timer = null;

    if (messages.length <= 1) {
      if (btnPrev) btnPrev.style.display = 'none';
      if (btnNext) btnNext.style.display = 'none';
      return;
    }

    function show(index) {
      messages[current].classList.add('announcement-bar__message--hidden');
      current = (index + messages.length) % messages.length;
      messages[current].classList.remove('announcement-bar__message--hidden');
    }

    function startTimer() {
      if (autorotateSeconds > 0) {
        timer = setInterval(function () { show(current + 1); }, autorotateSeconds * 1000);
      }
    }

    function stopTimer() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    if (btnPrev) {
      btnPrev.addEventListener('click', function () {
        stopTimer();
        show(current - 1);
        startTimer();
      });
    }

    if (btnNext) {
      btnNext.addEventListener('click', function () {
        stopTimer();
        show(current + 1);
        startTimer();
      });
    }

    bar.addEventListener('mouseenter', stopTimer);
    bar.addEventListener('mouseleave', startTimer);

    startTimer();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bespoke-enquiry"] && !Shopify.designMode) return;
  try {
    
(function () {
  var params = new URLSearchParams(window.location.search);
  var product = params.get('product');
  if (!product) return;

  document.querySelectorAll('.bespoke-enquiry').forEach(function (section) {
    var field = section.querySelector('[data-bespoke-product-field]');
    if (field && !field.value) {
      field.value = product;
    }

    var note = section.querySelector('[data-bespoke-product-note]');
    var label = section.querySelector('[data-bespoke-product-label]');
    if (note && label) {
      label.textContent = product;
      note.hidden = false;
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cage-finder-mini"] && !Shopify.designMode) return;
  try {
    
(function () {
  var roots = document.querySelectorAll('[data-finder-mini-root]');
  if (!roots.length) return;

  roots.forEach(function (root) {
    var controls = root.querySelector('[data-finder-controls]');
    if (!controls) return;

    var keys = ['w', 'h', 'd'];
    var ranges = {};
    var nums = {};

    keys.forEach(function (key) {
      ranges[key] = controls.querySelector('[data-finder-range="' + key + '"]');
      nums[key] = controls.querySelector('[data-finder-num="' + key + '"]');
    });

    function clamp(input, value) {
      var min = parseFloat(input.min);
      var max = parseFloat(input.max);
      if (!isNaN(min) && value < min) value = min;
      if (!isNaN(max) && value > max) value = max;
      return value;
    }

    keys.forEach(function (key) {
      var range = ranges[key];
      var num = nums[key];
      if (!range || !num) return;

      range.addEventListener('input', function () {
        num.value = range.value;
      });

      num.addEventListener('input', function () {
        var value = parseFloat(num.value);
        if (isNaN(value)) return;
        range.value = value;
      });

      num.addEventListener('change', function () {
        var value = parseFloat(num.value);
        if (isNaN(value)) {
          value = parseFloat(num.max);
        }
        value = clamp(num, value);
        num.value = value;
        range.value = value;
      });
    });

    var goBtn = root.querySelector('[data-finder-go]');
    if (goBtn) {
      goBtn.addEventListener('click', function () {
        var url = root.getAttribute('data-finder-url');
        if (!url) return;

        var parts = [];
        keys.forEach(function (key) {
          var num = nums[key];
          if (num) {
            parts.push(key + '=' + encodeURIComponent(num.value));
          }
        });

        var query = parts.join('&');
        var sep = url.indexOf('?') === -1 ? '?' : '&';
        window.location.href = url + sep + query;
      });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cage-finder"] && !Shopify.designMode) return;
  try {
    
(function () {
  var roots = document.querySelectorAll('[data-finder-root]');
  if (!roots.length) return;

  roots.forEach(function (root) {
    var controls = root.querySelector('[data-finder-controls]');
    var goBtn = root.querySelector('[data-finder-go]');
    if (!controls || !goBtn) return;

    var collectionUrl = root.getAttribute('data-collection-url');
    if (!collectionUrl) return;

    var keys = ['w', 'h', 'd'];
    var ranges = {};
    var nums = {};
    keys.forEach(function (key) {
      ranges[key] = controls.querySelector('[data-finder-range="' + key + '"]');
      nums[key] = controls.querySelector('[data-finder-num="' + key + '"]');
    });

    var closestCount = parseInt(root.getAttribute('data-closest'), 10);
    if (isNaN(closestCount) || closestCount < 1) closestCount = 4;
    var batchSize = parseInt(root.getAttribute('data-batch'), 10);
    if (isNaN(batchSize) || batchSize < 1) batchSize = 24;

    var loadingEl = root.querySelector('[data-finder-loading]');
    var resultsEl = root.querySelector('[data-finder-results]');
    var countEl = root.querySelector('[data-finder-count]');
    var closestEl = root.querySelector('[data-finder-closest]');
    var closestGrid = root.querySelector('[data-finder-closest-grid]');
    var moreEl = root.querySelector('[data-finder-more]');
    var moreGrid = root.querySelector('[data-finder-more-grid]');
    var showMoreBtn = root.querySelector('[data-finder-showmore]');
    var emptyEl = root.querySelector('[data-finder-empty]');
    var errorEl = root.querySelector('[data-finder-error]');

    var dataset = null;
    var moreItems = [];
    var moreShown = 0;

    function clamp(input, value) {
      var min = parseFloat(input.min);
      var max = parseFloat(input.max);
      if (!isNaN(min) && value < min) value = min;
      if (!isNaN(max) && value > max) value = max;
      return value;
    }

    keys.forEach(function (key) {
      var range = ranges[key];
      var num = nums[key];
      if (!range || !num) return;

      range.addEventListener('input', function () {
        num.value = range.value;
      });

      num.addEventListener('input', function () {
        var value = parseFloat(num.value);
        if (!isNaN(value)) range.value = value;
      });

      num.addEventListener('change', function () {
        var value = parseFloat(num.value);
        if (isNaN(value)) value = parseFloat(num.max);
        value = clamp(num, value);
        num.value = value;
        range.value = value;
      });
    });

    function setHidden(el, hidden) {
      if (el) el.hidden = hidden;
    }

    function showError() {
      setHidden(loadingEl, true);
      setHidden(resultsEl, false);
      setHidden(errorEl, false);
      setHidden(closestEl, true);
      setHidden(moreEl, true);
      setHidden(emptyEl, true);
      if (countEl) countEl.textContent = '';
    }

    function buildUrl(page) {
      var sep = collectionUrl.indexOf('?') === -1 ? '?' : '&';
      return collectionUrl + sep + 'view=cage-data&page=' + page;
    }

    function fetchPage(page) {
      var url = buildUrl(page);
      return fetch(url, { headers: { Accept: 'text/html' } }).then(function (res) {
        return res.text().then(function (text) {
          if (!res.ok) throw new Error('HTTP ' + res.status + ' for ' + url);
          try {
            return JSON.parse(text);
          } catch (e) {
            throw new Error('Non-JSON from ' + url + ' :: ' + text.slice(0, 140));
          }
        });
      });
    }

    function loadDataset() {
      if (dataset) return Promise.resolve(dataset);

      var cached = null;
      try {
        cached = window.sessionStorage.getItem(collectionUrl);
      } catch (e) {
        cached = null;
      }
      if (cached) {
        try {
          dataset = JSON.parse(cached);
          if (dataset && dataset.length) return Promise.resolve(dataset);
        } catch (e) {
          dataset = null;
        }
      }

      return fetchPage(1).then(function (firstPage) {
        var all = (firstPage.products || []).slice();
        var totalPages = firstPage.pages || 1;
        if (totalPages <= 1) return all;

        var rest = [];
        for (var p = 2; p <= totalPages; p++) {
          rest.push(fetchPage(p));
        }
        return Promise.all(rest).then(function (pages) {
          pages.forEach(function (pg) {
            if (pg && pg.products) all = all.concat(pg.products);
          });
          return all;
        });
      }).then(function (all) {
        dataset = all;
        try {
          window.sessionStorage.setItem(collectionUrl, JSON.stringify(all));
        } catch (e) {}
        return all;
      });
    }

    function readMax(key) {
      var num = nums[key];
      var value = parseFloat(num.value);
      if (isNaN(value)) value = parseFloat(num.max);
      if (isNaN(value)) value = Infinity;
      return value;
    }

    function makeCard(item) {
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.className = 'cage-card';
      a.href = item.u;

      var media = document.createElement('div');
      media.className = 'cage-card__media';
      if (item.i) {
        var img = document.createElement('img');
        img.className = 'cage-card__img';
        img.src = item.i;
        img.alt = item.t;
        img.loading = 'lazy';
        img.width = 360;
        img.height = 270;
        media.appendChild(img);
      } else {
        var ph = document.createElement('span');
        ph.className = 'cage-card__placeholder';
        ph.textContent = 'No image';
        media.appendChild(ph);
      }
      a.appendChild(media);

      var title = document.createElement('p');
      title.className = 'cage-card__title';
      title.textContent = item.t;
      a.appendChild(title);

      var price = document.createElement('p');
      price.className = 'cage-card__price';
      price.textContent = item.p;
      a.appendChild(price);

      var dims = document.createElement('div');
      dims.className = 'cage-card__specs';
      [['W', item.w], ['H', item.h], ['D', item.d]].forEach(function (pair) {
        var spec = document.createElement('span');
        spec.className = 'cage-card__spec';
        var lab = document.createElement('span');
        lab.className = 'cage-card__spec-label';
        lab.textContent = pair[0];
        spec.appendChild(lab);
        spec.appendChild(document.createTextNode(' ' + Math.round(pair[1]) + ' mm'));
        dims.appendChild(spec);
      });
      a.appendChild(dims);

      li.appendChild(a);
      return li;
    }

    function renderMoreBatch() {
      var next = moreItems.slice(moreShown, moreShown + batchSize);
      next.forEach(function (item) {
        moreGrid.appendChild(makeCard(item));
      });
      moreShown += next.length;
      setHidden(showMoreBtn, moreShown >= moreItems.length);
    }

    function render(matches) {
      closestGrid.innerHTML = '';
      moreGrid.innerHTML = '';
      moreItems = [];
      moreShown = 0;

      setHidden(errorEl, true);

      if (countEl) {
        countEl.textContent = matches.length + (matches.length === 1 ? ' box fits' : ' boxes fit');
      }

      if (!matches.length) {
        setHidden(closestEl, true);
        setHidden(moreEl, true);
        setHidden(emptyEl, false);
        return;
      }

      setHidden(emptyEl, true);

      var closest = matches.slice(0, closestCount);
      closest.forEach(function (item) {
        closestGrid.appendChild(makeCard(item));
      });
      setHidden(closestEl, false);

      moreItems = matches.slice(closestCount);
      if (moreItems.length) {
        setHidden(moreEl, false);
        renderMoreBatch();
      } else {
        setHidden(moreEl, true);
      }
    }

    function runFinder() {
      setHidden(loadingEl, false);
      setHidden(resultsEl, true);

      loadDataset().then(function (all) {
        var maxW = readMax('w');
        var maxH = readMax('h');
        var maxD = readMax('d');

        var matches = all.filter(function (item) {
          return item.w <= maxW && item.h <= maxH && item.d <= maxD;
        });

        matches.sort(function (a, b) {
          return (b.w * b.h * b.d) - (a.w * a.h * a.d);
        });

        setHidden(loadingEl, true);
        setHidden(resultsEl, false);
        render(matches);
      }).catch(function () {
        showError();
      });
    }

    goBtn.addEventListener('click', runFinder);

    if (showMoreBtn) {
      showMoreBtn.addEventListener('click', renderMoreBatch);
    }

    var params = new URLSearchParams(window.location.search);
    var hasParams = false;
    keys.forEach(function (key) {
      var raw = params.get(key);
      if (raw === null) return;
      var value = parseFloat(raw);
      if (isNaN(value)) return;
      hasParams = true;
      var range = ranges[key];
      var num = nums[key];
      if (range && num) {
        value = clamp(num, value);
        num.value = value;
        range.value = value;
      }
    });

    if (hasParams) {
      runFinder();
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-cages"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-cages-collection]').forEach(function (root) {
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-cages-item]'));
    var ranges = Array.prototype.slice.call(root.querySelectorAll('[data-cages-range]'));
    var nums = Array.prototype.slice.call(root.querySelectorAll('[data-cages-num]'));
    var feats = Array.prototype.slice.call(root.querySelectorAll('[data-cages-feature]'));
    var countEl = root.querySelector('[data-cages-count]');
    var emptyEl = root.querySelector('[data-cages-empty]');
    var resetBtn = root.querySelector('[data-cages-reset]');

    function toNum(s) {
      if (s === null || s === '') return null;
      var v = parseFloat(s);
      return isNaN(v) ? null : v;
    }

    function rangeFor(key) { return root.querySelector('[data-cages-range="' + key + '"]'); }
    function numFor(key) { return root.querySelector('[data-cages-num="' + key + '"]'); }

    // The number box is the source of truth so a typed value above the slider max still works.
    function maxFor(key) {
      var n = numFor(key);
      if (n) {
        var v = parseFloat(n.value);
        if (!isNaN(v)) return v;
      }
      return Infinity;
    }

    function clampNum(input, value) {
      var min = parseFloat(input.min);
      var max = parseFloat(input.max);
      if (!isNaN(min) && value < min) value = min;
      if (!isNaN(max) && value > max) value = max;
      return value;
    }

    function apply() {
      var maxW = maxFor('w');
      var maxH = maxFor('h');
      var maxD = maxFor('d');
      var checked = feats.filter(function (f) { return f.checked; }).map(function (f) { return f.value; });
      var shown = 0;

      items.forEach(function (li) {
        var w = toNum(li.getAttribute('data-w'));
        var h = toNum(li.getAttribute('data-h'));
        var d = toNum(li.getAttribute('data-d'));
        var ok = (w === null || w <= maxW) && (h === null || h <= maxH) && (d === null || d <= maxD);
        if (ok && checked.length) {
          var have = (li.getAttribute('data-features') || '').split(' ');
          ok = checked.every(function (c) { return have.indexOf(c) !== -1; });
        }
        li.classList.toggle('is-hidden', !ok);
        if (ok) shown++;
      });

      if (countEl) countEl.textContent = 'Showing ' + shown + (shown === 1 ? ' cage' : ' cages');
      if (emptyEl) emptyEl.hidden = shown !== 0;
    }

    ranges.forEach(function (r) {
      var key = r.getAttribute('data-cages-range');
      r.addEventListener('input', function () {
        var n = numFor(key);
        if (n) n.value = r.value;
        apply();
      });
    });

    nums.forEach(function (n) {
      var key = n.getAttribute('data-cages-num');
      n.addEventListener('input', function () {
        var r = rangeFor(key);
        var v = parseFloat(n.value);
        if (r && !isNaN(v)) r.value = v;
        apply();
      });
      n.addEventListener('change', function () {
        var v = parseFloat(n.value);
        if (isNaN(v)) v = parseFloat(n.max);
        v = clampNum(n, v);
        n.value = v;
        var r = rangeFor(key);
        if (r) r.value = v;
        apply();
      });
    });

    feats.forEach(function (f) {
      f.addEventListener('change', apply);
    });

    if (resetBtn) {
      resetBtn.addEventListener('click', function () {
        ranges.forEach(function (r) { r.value = r.max; });
        nums.forEach(function (n) { n.value = n.max; });
        feats.forEach(function (f) { f.checked = false; });
        apply();
      });
    }

    var filterToggle = root.querySelector('[data-cages-filter-toggle]');
    var filterPanel = root.querySelector('[data-cages-filter-panel]');
    if (filterToggle && filterPanel) {
      filterToggle.addEventListener('click', function () {
        var open = filterPanel.classList.toggle('is-open');
        filterToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }

    apply();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["combined-finder"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-combined-finder]').forEach(function (root) {
    // Tab switching
    var tabs = root.querySelectorAll('[data-cf-tab]');
    var panes = root.querySelectorAll('[data-cf-pane]');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var key = tab.getAttribute('data-cf-tab');
        tabs.forEach(function (t) {
          t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
        });
        panes.forEach(function (p) {
          p.setAttribute('aria-hidden', p.getAttribute('data-cf-pane') !== key ? 'true' : 'false');
        });
      });
    });

    // Size finder: keep slider and number in sync, then go to the cage finder page
    var controls = root.querySelector('[data-cf-size-controls]');
    if (!controls) return;
    var keys = ['w', 'h', 'd'];
    var ranges = {};
    var nums = {};
    keys.forEach(function (key) {
      ranges[key] = controls.querySelector('[data-finder-range="' + key + '"]');
      nums[key] = controls.querySelector('[data-finder-num="' + key + '"]');
    });

    function clamp(input, value) {
      var min = parseFloat(input.min);
      var max = parseFloat(input.max);
      if (!isNaN(min) && value < min) value = min;
      if (!isNaN(max) && value > max) value = max;
      return value;
    }

    keys.forEach(function (key) {
      var range = ranges[key];
      var num = nums[key];
      if (!range || !num) return;
      range.addEventListener('input', function () { num.value = range.value; });
      num.addEventListener('input', function () {
        var v = parseFloat(num.value);
        if (!isNaN(v)) range.value = v;
      });
      num.addEventListener('change', function () {
        var v = parseFloat(num.value);
        if (isNaN(v)) v = parseFloat(num.max);
        v = clamp(num, v);
        num.value = v;
        range.value = v;
      });
    });

    var go = root.querySelector('[data-cf-size-go]');
    if (go) {
      go.addEventListener('click', function () {
        var url = root.getAttribute('data-finder-url');
        if (!url) return;
        var parts = [];
        keys.forEach(function (key) {
          if (nums[key]) parts.push(key + '=' + encodeURIComponent(nums[key].value));
        });
        var sep = url.indexOf('?') === -1 ? '?' : '&';
        window.location.href = url + sep + parts.join('&');
      });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.site-header').forEach(function (header) {
    var burger = header.querySelector('.site-header__burger');
    var drawer = document.getElementById('site-nav-drawer');
    var drawerClose = drawer ? drawer.querySelector('.site-nav-drawer__close') : null;
    var drawerOverlay = drawer ? drawer.querySelector('.site-nav-drawer__overlay') : null;
    var drawerPanel = drawer ? drawer.querySelector('.site-nav-drawer__panel') : null;

    function openDrawer() {
      if (!drawer) return;
      drawer.setAttribute('aria-hidden', 'false');
      if (burger) burger.setAttribute('aria-expanded', 'true');
      document.body.classList.add('site-nav-drawer--open');
      var firstFocusable = drawerPanel ? drawerPanel.querySelector('a, button, input, [tabindex="0"]') : null;
      if (firstFocusable) firstFocusable.focus();
    }

    function closeDrawer() {
      if (!drawer) return;
      drawer.setAttribute('aria-hidden', 'true');
      if (burger) {
        burger.setAttribute('aria-expanded', 'false');
        burger.focus();
      }
      document.body.classList.remove('site-nav-drawer--open');
    }

    if (burger) {
      burger.addEventListener('click', function () {
        var isOpen = drawer && drawer.getAttribute('aria-hidden') === 'false';
        if (isOpen) {
          closeDrawer();
        } else {
          openDrawer();
        }
      });
    }

    if (drawerClose) {
      drawerClose.addEventListener('click', closeDrawer);
    }

    if (drawerOverlay) {
      drawerOverlay.addEventListener('click', closeDrawer);
    }

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        if (drawer && drawer.getAttribute('aria-hidden') === 'false') {
          closeDrawer();
        }
        var searchPanel = header.querySelector('.site-header__search-panel');
        var searchToggle = header.querySelector('.site-header__search-toggle');
        if (searchPanel && !searchPanel.hidden) {
          searchPanel.hidden = true;
          if (searchToggle) {
            searchToggle.setAttribute('aria-expanded', 'false');
            searchToggle.setAttribute('aria-label', searchToggle.dataset.labelOpen);
            searchToggle.focus();
          }
        }
        var desktopNav = header.querySelector('.site-header__nav');
        if (desktopNav) {
          var openDesktopDetails = desktopNav.querySelectorAll('.site-header__dropdown[open]');
          openDesktopDetails.forEach(function (det) {
            var sum = det.querySelector('summary');
            det.open = false;
            if (sum) sum.focus();
          });
        }
      }
    });

    var searchToggle = header.querySelector('.site-header__search-toggle');
    var searchPanel = header.querySelector('.site-header__search-panel');
    var searchInput = header.querySelector('.site-header__search-input');

    if (searchToggle && searchPanel) {
      searchToggle.addEventListener('click', function () {
        var isOpen = !searchPanel.hidden;
        if (isOpen) {
          searchPanel.hidden = true;
          searchToggle.setAttribute('aria-expanded', 'false');
          searchToggle.setAttribute('aria-label', searchToggle.dataset.labelOpen);
        } else {
          searchPanel.hidden = false;
          searchToggle.setAttribute('aria-expanded', 'true');
          searchToggle.setAttribute('aria-label', searchToggle.dataset.labelClose);
          if (searchInput) searchInput.focus();
        }
      });

      document.addEventListener('click', function (event) {
        var searchWrap = header.querySelector('.site-header__search-wrap');
        if (searchWrap && !searchWrap.contains(event.target) && !searchPanel.hidden) {
          searchPanel.hidden = true;
          searchToggle.setAttribute('aria-expanded', 'false');
          searchToggle.setAttribute('aria-label', searchToggle.dataset.labelOpen);
        }
      });
    }

    // Predictive search: live results injected from the predictive-search section
    document.querySelectorAll('[data-predictive-url]').forEach(function (form) {
      var endpoint = form.getAttribute('data-predictive-url');
      var input = form.querySelector('input[name="q"]');
      var results = form.parentElement ? form.parentElement.querySelector('[data-predictive-results]') : null;
      if (!endpoint || !input || !results) return;

      var debounceTimer;
      var controller;

      function hideResults() {
        results.hidden = true;
        results.innerHTML = '';
        input.setAttribute('aria-expanded', 'false');
      }

      function fetchResults() {
        var term = input.value.trim();
        if (term.length < 2) { hideResults(); return; }
        if (controller) controller.abort();
        controller = new AbortController();
        var url = endpoint + '?q=' + encodeURIComponent(term) +
          '&section_id=predictive-search' +
          '&resources[type]=product,page,article&resources[limit]=6&resources[limit_scope]=each';
        fetch(url, { signal: controller.signal })
          .then(function (response) { return response.text(); })
          .then(function (html) {
            results.innerHTML = html;
            results.hidden = false;
            input.setAttribute('aria-expanded', 'true');
          })
          .catch(function () { /* request aborted or offline */ });
      }

      input.addEventListener('input', function () {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(fetchResults, 250);
      });

      input.addEventListener('focus', function () {
        if (input.value.trim().length >= 2 && results.innerHTML.trim()) {
          results.hidden = false;
        }
      });

      input.addEventListener('keydown', function (event) {
        if (results.hidden) return;
        var items = Array.prototype.slice.call(results.querySelectorAll('a'));
        if (!items.length) return;
        var current = items.indexOf(document.activeElement);
        if (event.key === 'ArrowDown') {
          event.preventDefault();
          (items[current + 1] || items[0]).focus();
        } else if (event.key === 'ArrowUp') {
          event.preventDefault();
          (current <= 0 ? items[items.length - 1] : items[current - 1]).focus();
        }
      });

      document.addEventListener('click', function (event) {
        if (form.parentElement && !form.parentElement.contains(event.target)) hideResults();
      });
    });

    var desktop = window.matchMedia('(min-width: 769px)');
    desktop.addEventListener('change', function (e) {
      if (e.matches) closeDrawer();
    });

    var desktopNav = header.querySelector('.site-header__nav');
    if (desktopNav) {
      var desktopDropdowns = desktopNav.querySelectorAll('.site-header__dropdown');

      desktopDropdowns.forEach(function (det) {
        var closeTimer;
        var canHover = function () {
          return window.matchMedia('(hover: hover) and (pointer: fine)').matches;
        };

        det.addEventListener('mouseenter', function () {
          if (!canHover()) return;
          clearTimeout(closeTimer);
          det.open = true;
        });

        det.addEventListener('mouseleave', function () {
          if (!canHover()) return;
          clearTimeout(closeTimer);
          closeTimer = setTimeout(function () {
            det.open = false;
          }, 200);
        });

        det.addEventListener('toggle', function () {
          if (det.open) {
            desktopDropdowns.forEach(function (other) {
              if (other !== det && other.open) {
                other.open = false;
              }
            });
          }
        });
      });

      document.addEventListener('click', function (event) {
        desktopDropdowns.forEach(function (det) {
          if (det.open && !det.contains(event.target)) {
            det.open = false;
          }
        });
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-addresses"]) return;
  try {
    
(function () {
  // Country / province selector (vanilla, no dependencies)
  function populateProvince(countrySelect) {
    var provinceId = countrySelect.getAttribute('data-province-target');
    var province = document.getElementById(provinceId);
    if (!province) return;
    var container = document.getElementById(province.getAttribute('data-province-container'));
    var selected = countrySelect.options[countrySelect.selectedIndex];
    var raw = selected ? selected.getAttribute('data-provinces') : null;
    var provinces = [];
    try { provinces = raw ? JSON.parse(raw) : []; } catch (e) { provinces = []; }

    province.innerHTML = '';
    if (!provinces.length) {
      if (container) container.style.display = 'none';
      province.disabled = true;
      return;
    }
    province.disabled = false;
    var def = province.getAttribute('data-default') || '';
    provinces.forEach(function (p) {
      var opt = document.createElement('option');
      opt.value = p[0];
      opt.textContent = p[1];
      if (p[0] === def) opt.selected = true;
      province.appendChild(opt);
    });
    if (container) container.style.display = '';
  }

  document.querySelectorAll('[data-address-country]').forEach(function (sel) {
    var def = sel.getAttribute('data-default');
    if (def) {
      Array.prototype.forEach.call(sel.options, function (o) {
        if (o.value === def) o.selected = true;
      });
    }
    populateProvince(sel);
    sel.addEventListener('change', function () { populateProvince(sel); });
  });

  function toggleForm(form, toggle, open) {
    form.hidden = !open;
    if (toggle) toggle.setAttribute('aria-expanded', String(open));
    if (open) {
      var first = form.querySelector('input, select');
      if (first) first.focus();
    }
  }

  // New-address form
  document.querySelectorAll('[data-address-new]').forEach(function (btn) {
    var form = document.getElementById('AddressNewForm');
    if (!form) return;
    btn.addEventListener('click', function () { toggleForm(form, btn, form.hidden); });
  });
  document.querySelectorAll('[data-address-new-cancel]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      toggleForm(document.getElementById('AddressNewForm'), document.querySelector('[data-address-new]'), false);
    });
  });

  // Edit forms
  document.querySelectorAll('[data-address-edit]').forEach(function (btn) {
    var id = btn.getAttribute('data-address-edit');
    var form = document.getElementById('EditAddress' + id);
    if (!form) return;
    btn.addEventListener('click', function () { toggleForm(form, btn, form.hidden); });
  });
  document.querySelectorAll('[data-address-edit-cancel]').forEach(function (btn) {
    var id = btn.getAttribute('data-address-edit-cancel');
    btn.addEventListener('click', function () {
      toggleForm(document.getElementById('EditAddress' + id), document.querySelector('[data-address-edit="' + id + '"]'), false);
    });
  });

  // Confirm before deleting
  document.querySelectorAll('[data-address-delete]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      var btn = form.querySelector('[data-confirm]');
      var message = btn ? btn.getAttribute('data-confirm') : 'Delete this address?';
      if (!window.confirm(message)) e.preventDefault();
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"] && !Shopify.designMode) return;
  try {
    
(function () {
  var form = document.getElementById('CollectionFiltersForm');
  if (!form) return;

  // Hide all "Apply" buttons when JS is running — change handler submits instead
  var applyBtns = form.querySelectorAll('.collection-filter__apply-btn');
  applyBtns.forEach(function (btn) {
    btn.style.display = 'none';
  });

  // Auto-submit on checkbox/select change
  form.addEventListener('change', function (e) {
    var el = e.target;
    if (el.tagName === 'SELECT' || el.type === 'checkbox') {
      form.submit();
    }
  });

  // Price-range inputs: submit on Enter key
  var priceInputs = form.querySelectorAll('.collection-filter__price-input');
  priceInputs.forEach(function (input) {
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        form.submit();
      }
    });
    // Re-show the apply button for price range panels (can't submit on change for number inputs)
    var panel = input.closest('.collection-filter__panel');
    if (panel) {
      var btn = panel.querySelector('.collection-filter__apply-btn');
      if (btn) btn.style.display = '';
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-login"]) return;
  try {
    
(function () {
  document.querySelectorAll('.customer').forEach(function (root) {
    var login = root.querySelector('[data-login-panel]');
    var recover = root.querySelector('[data-recover-panel]');
    if (!login || !recover) return;

    function show(panel) {
      login.hidden = panel !== 'login';
      recover.hidden = panel !== 'recover';
    }

    root.querySelectorAll('[data-recover-show]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        show('recover');
        var input = recover.querySelector('input[type="email"]');
        if (input) input.focus();
      });
    });

    root.querySelectorAll('[data-recover-hide]').forEach(function (btn) {
      btn.addEventListener('click', function () { show('login'); });
    });

    var recoverActive = window.location.hash === '#recover'
      || recover.querySelector('.customer-errors')
      || recover.querySelector('.customer-message');
    if (recoverActive) show('recover');
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.main-product').forEach(function (section) {
    var sectionId = section.id.replace('MainProduct-', '');

    var galleryMain    = section.querySelector('.product-gallery__main');
    var thumbContainer = section.querySelector('.product-gallery__thumbs');
    var galleryMobile  = window.matchMedia('(max-width: 989px)');
    var priceEl        = section.querySelector('[id^="ProductPrice-"]');
    var variantIdInput = section.querySelector('[id^="ProductVariantId-"]');
    var addToCartBtn   = section.querySelector('[id^="AddToCart-"]');
    var variantsJson   = section.querySelector('[id^="ProductVariantsJSON-"]');
    var variantPicker  = section.querySelector('[id^="ProductVariants-"]');
    var qtyInput       = section.querySelector('[id^="QuantityInput-"]');
    var inventoryEl    = section.querySelector('[id^="ProductInventory-"]');
    var backorderEl    = section.querySelector('[id^="ProductBackorder-"]');
    var pickupEl       = section.querySelector('[id^="ProductPickup-"]');

    var customColourEl     = section.querySelector('[id^="CustomColour-"]');
    var customColourSelect = customColourEl ? customColourEl.querySelector('.product__custom-colour-select') : null;
    var ccCombo            = customColourEl ? customColourEl.querySelector('[data-cc-combo]') : null;
    var ccButton           = ccCombo ? ccCombo.querySelector('[data-cc-button]') : null;
    var ccPanel            = ccCombo ? ccCombo.querySelector('[data-cc-panel]') : null;
    var ccSearch           = ccCombo ? ccCombo.querySelector('[data-cc-search]') : null;
    var ccList             = ccCombo ? ccCombo.querySelector('[data-cc-list]') : null;
    var ccEmpty            = ccCombo ? ccCombo.querySelector('[data-cc-empty]') : null;
    var ccSwatch           = ccCombo ? ccCombo.querySelector('[data-cc-swatch]') : null;
    var ccText             = ccCombo ? ccCombo.querySelector('[data-cc-text]') : null;
    var ccActiveIndex      = -1;

    var productHandle  = section.dataset.productHandle || '';
    var routesRoot     = section.dataset.routesRoot || '/';

    var showPickup     = false;
    var lowThreshold   = 0;
    var showCount      = false;

    if (inventoryEl) {
      lowThreshold = parseInt(inventoryEl.dataset.lowStockThreshold, 10) || 0;
      showCount    = inventoryEl.dataset.showInventoryCount === 'true';
    }
    if (pickupEl) {
      showPickup = pickupEl.dataset.showPickup === 'true';
    }

    var variants = [];
    if (variantsJson) {
      try { variants = JSON.parse(variantsJson.textContent); } catch (e) {}
    }

    var invData = {};
    var invJsonEl = section.querySelector('[id^="ProductInventoryJSON-"]');
    if (invJsonEl) {
      try { invData = JSON.parse(invJsonEl.textContent); } catch (e) {}
    }

    var moneyFormat = section.dataset.moneyFormat || ('£' + '\x7B\x7Bamount\x7D\x7D');

    function formatMoney(cents) {
      var amount = (cents / 100).toFixed(2);
      return moneyFormat.replace(/\{\{.*?\}\}/, amount);
    }

    function updatePrice(variant) {
      if (!priceEl) return;
      var html = '';
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        html  = '<span class="product__price-sale">' + formatMoney(variant.price) + '</span>';
        html += '<s class="product__price-compare">' + formatMoney(variant.compare_at_price) + '</s>';
        html += '<span class="product__badge product__badge--sale" aria-label="Sale">Sale</span>';
      } else {
        html = '<span class="product__price-current">' + formatMoney(variant.price) + '</span>';
      }
      priceEl.innerHTML = html;
    }

    function updateAddToCart(variant) {
      if (!addToCartBtn) return;
      if (variant.available) {
        addToCartBtn.disabled = false;
        addToCartBtn.removeAttribute('aria-disabled');
        addToCartBtn.textContent = 'Add to cart';
      } else {
        addToCartBtn.disabled = true;
        addToCartBtn.setAttribute('aria-disabled', 'true');
        addToCartBtn.textContent = 'Sold out';
      }
    }

    function updateInventory(variant) {
      if (!inventoryEl) return;
      var inv    = invData[variant.id] || {};
      var qty    = typeof inv.qty    !== 'undefined' ? inv.qty    : 0;
      var mgmt   = typeof inv.mgmt   !== 'undefined' ? inv.mgmt   : false;
      var policy = typeof inv.policy !== 'undefined' ? inv.policy : null;
      var avail  = typeof inv.available !== 'undefined' ? inv.available : variant.available;

      var isBackorder = (mgmt && qty <= 0 && avail === true && policy === 'continue');

      if (isBackorder) {
        inventoryEl.innerHTML = '';
        return;
      }

      var statusClass, statusText;
      if (!mgmt) {
        statusClass = 'product__inventory-status--in';
        statusText  = 'In stock';
      } else if (qty > lowThreshold) {
        statusClass = 'product__inventory-status--in';
        statusText  = 'In stock';
      } else if (qty > 0) {
        statusClass = 'product__inventory-status--low';
        statusText  = showCount ? 'Low stock, only ' + qty + ' left' : 'Low stock';
      } else {
        statusClass = 'product__inventory-status--out';
        statusText  = 'Out of stock';
      }

      inventoryEl.innerHTML = '<span class="product__inventory-status ' + statusClass + '">' + statusText + '</span>';
    }

    function updateBackorder(variant) {
      if (!backorderEl) return;
      var inv    = invData[variant.id] || {};
      var qty    = typeof inv.qty    !== 'undefined' ? inv.qty    : 0;
      var mgmt   = typeof inv.mgmt   !== 'undefined' ? inv.mgmt   : false;
      var policy = typeof inv.policy !== 'undefined' ? inv.policy : null;
      var avail  = typeof inv.available !== 'undefined' ? inv.available : variant.available;
      var isBackorder = (mgmt && qty <= 0 && avail === true && policy === 'continue');
      if (isBackorder) {
        backorderEl.removeAttribute('hidden');
      } else {
        backorderEl.setAttribute('hidden', '');
      }
    }

    function updatePickup(variantId) {
      if (!pickupEl || !showPickup || !productHandle) return;
      // Backorder variants (out of stock, continue selling) must not show pickup. The
      // server already omits it, but the async fetch below would leave the previous
      // variant's pickup line visible until it returns. Clear it now and skip the fetch.
      var binv    = invData[variantId] || {};
      var bqty    = typeof binv.qty !== 'undefined' ? binv.qty : 0;
      var isBackorder = (binv.mgmt === true && bqty <= 0 && binv.available === true && binv.policy === 'continue');
      if (isBackorder) {
        pickupEl.innerHTML = '';
        return;
      }
      var root = routesRoot.replace(/\/$/, '');
      var url  = root + '/products/' + productHandle + '?variant=' + variantId + '&section_id=' + sectionId;
      fetch(url)
        .then(function (response) {
          if (!response.ok) throw new Error('SRA fetch failed: ' + response.status);
          return response.text();
        })
        .then(function (html) {
          var parser    = new DOMParser();
          var doc       = parser.parseFromString(html, 'text/html');
          var newPickup = doc.querySelector('[id^="ProductPickup-"]');
          if (newPickup) {
            pickupEl.innerHTML = newPickup.innerHTML;
          }
        })
        .catch(function () {});
    }

    function getSelectedOptions() {
      if (!variantPicker) return [];
      var options = [];
      variantPicker.querySelectorAll('[data-option-index]').forEach(function (radio) {
        if (radio.checked) {
          options[parseInt(radio.dataset.optionIndex, 10)] = radio.value;
        }
      });
      return options;
    }

    function findVariant(selectedOptions) {
      return variants.find(function (v) {
        return v.options.every(function (opt, i) {
          return opt === selectedOptions[i];
        });
      }) || null;
    }

    function ccVisibleRows() {
      if (!ccList) return [];
      var rows = [];
      ccList.querySelectorAll('[role="option"]').forEach(function (li) {
        if (!li.hidden) rows.push(li);
      });
      return rows;
    }

    function ccSetActive(newIndex) {
      var rows = ccVisibleRows();
      if (!rows.length) {
        ccActiveIndex = -1;
        if (ccSearch) ccSearch.removeAttribute('aria-activedescendant');
        return;
      }
      if (newIndex < 0) newIndex = 0;
      if (newIndex > rows.length - 1) newIndex = rows.length - 1;
      ccActiveIndex = newIndex;
      rows.forEach(function (li, i) {
        var active = i === ccActiveIndex;
        li.classList.toggle('is-active', active);
        if (active) {
          if (ccSearch) ccSearch.setAttribute('aria-activedescendant', li.id);
          if (li.scrollIntoView) li.scrollIntoView({ block: 'nearest' });
        }
      });
    }

    function ccFilter(term) {
      if (!ccList) return;
      term = (term || '').toLowerCase().trim();
      var anyVisible = false;
      ccList.querySelectorAll('[role="option"]').forEach(function (li) {
        var hay = (li.dataset.code + ' ' + li.dataset.name).toLowerCase();
        var show = term === '' || hay.indexOf(term) !== -1;
        li.hidden = !show;
        li.classList.remove('is-active');
        if (show) anyVisible = true;
      });
      if (ccEmpty) ccEmpty.hidden = anyVisible;
      ccActiveIndex = -1;
      if (ccSearch) ccSearch.removeAttribute('aria-activedescendant');
    }

    function ccClosePanel(focusButton) {
      if (!ccPanel || !ccButton) return;
      ccPanel.hidden = true;
      ccButton.setAttribute('aria-expanded', 'false');
      if (ccSearch) ccSearch.setAttribute('aria-expanded', 'false');
      ccActiveIndex = -1;
      if (ccSearch) ccSearch.removeAttribute('aria-activedescendant');
      if (focusButton) ccButton.focus();
    }

    function ccOpenPanel() {
      if (!ccPanel || !ccButton) return;
      ccPanel.hidden = false;
      ccButton.setAttribute('aria-expanded', 'true');
      if (ccSearch) {
        ccSearch.setAttribute('aria-expanded', 'true');
        ccSearch.value = '';
        ccFilter('');
        ccSearch.focus();
      }
    }

    function ccApplyValue(value, code, name, hex) {
      if (ccSwatch) ccSwatch.style.backgroundColor = hex || '';
      if (ccText) ccText.textContent = (code && name) ? (code + ' ' + name) : 'Select a RAL colour';
      if (ccList) {
        ccList.querySelectorAll('[role="option"]').forEach(function (li) {
          li.setAttribute('aria-selected', li.dataset.value === value ? 'true' : 'false');
        });
      }
    }

    function ccSelectRow(li) {
      if (!li || !customColourSelect) return;
      customColourSelect.value = li.dataset.value;
      customColourSelect.dispatchEvent(new Event('change', { bubbles: true }));
      ccApplyValue(li.dataset.value, li.dataset.code, li.dataset.name, li.dataset.hex);
      ccClosePanel(true);
    }

    function ccReflectSelect() {
      if (!customColourSelect) return;
      var opt = customColourSelect.options[customColourSelect.selectedIndex];
      if (opt && opt.value) {
        ccApplyValue(opt.value, opt.dataset.code || '', opt.dataset.name || '', opt.dataset.hex || '');
      } else {
        ccApplyValue('', '', '', '');
      }
    }

    function ccBuild() {
      if (!customColourEl || !customColourSelect || !ccCombo || !ccList) return;
      var baseId = customColourEl.id + '-opt-';
      var i;
      for (i = 0; i < customColourSelect.options.length; i++) {
        var opt = customColourSelect.options[i];
        if (!opt.value) continue;
        var li = document.createElement('li');
        li.setAttribute('role', 'option');
        li.id = baseId + i;
        li.className = 'product__cc-option';
        li.dataset.value = opt.value;
        li.dataset.hex = opt.dataset.hex || '';
        li.dataset.code = opt.dataset.code || '';
        li.dataset.name = opt.dataset.name || '';
        li.setAttribute('aria-selected', 'false');

        var sw = document.createElement('span');
        sw.className = 'product__cc-option-swatch';
        sw.setAttribute('aria-hidden', 'true');
        sw.style.backgroundColor = opt.dataset.hex || '';

        var codeEl = document.createElement('span');
        codeEl.className = 'product__cc-option-code';
        codeEl.textContent = opt.dataset.code || '';

        var nameEl = document.createElement('span');
        nameEl.className = 'product__cc-option-name';
        nameEl.textContent = opt.dataset.name || '';

        li.appendChild(sw);
        li.appendChild(codeEl);
        li.appendChild(nameEl);
        ccList.appendChild(li);
      }

      customColourSelect.classList.add('product__custom-colour-select--enhanced');
      ccCombo.hidden = false;
      ccReflectSelect();

      ccButton.addEventListener('click', function () {
        if (ccPanel.hidden) ccOpenPanel(); else ccClosePanel(false);
      });

      if (ccSearch) {
        ccSearch.addEventListener('input', function () {
          ccFilter(ccSearch.value);
        });
      }

      ccList.addEventListener('mousedown', function (e) {
        // Keep focus on the search input when pressing an option. Without this the
        // input blurs, focusout fires, and the panel can close before the click
        // selects the option, making selection appear to do nothing.
        e.preventDefault();
      });

      ccList.addEventListener('click', function (e) {
        var li = e.target.closest('[role="option"]');
        if (li) ccSelectRow(li);
      });

      ccList.addEventListener('mousemove', function (e) {
        var li = e.target.closest('[role="option"]');
        if (!li) return;
        var rows = ccVisibleRows();
        var idx = rows.indexOf(li);
        if (idx !== -1 && idx !== ccActiveIndex) ccSetActive(idx);
      });

      ccPanel.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown') {
          e.preventDefault();
          ccSetActive(ccActiveIndex + 1);
        } else if (e.key === 'ArrowUp') {
          e.preventDefault();
          ccSetActive(ccActiveIndex - 1);
        } else if (e.key === 'Enter') {
          e.preventDefault();
          var rows = ccVisibleRows();
          if (ccActiveIndex >= 0 && rows[ccActiveIndex]) ccSelectRow(rows[ccActiveIndex]);
        } else if (e.key === 'Escape') {
          e.preventDefault();
          ccClosePanel(true);
        } else if (e.key === 'Tab') {
          ccClosePanel(false);
        }
      });

      document.addEventListener('click', function (e) {
        if (!ccCombo.contains(e.target) && !ccPanel.hidden) ccClosePanel(false);
      });

      ccCombo.addEventListener('focusout', function () {
        window.setTimeout(function () {
          if (ccCombo && !ccCombo.contains(document.activeElement) && ccPanel && !ccPanel.hidden) {
            ccClosePanel(false);
          }
        }, 0);
      });
    }

    function updateCustomColour() {
      if (!customColourEl || !customColourSelect) return;
      var trigger = customColourEl.dataset.trigger || '';
      var selectedOptions = getSelectedOptions();
      var show = selectedOptions.indexOf(trigger) !== -1;
      if (show) {
        customColourEl.removeAttribute('hidden');
        customColourSelect.disabled = false;
      } else {
        customColourEl.setAttribute('hidden', '');
        customColourSelect.disabled = true;
        customColourSelect.value = '';
        ccApplyValue('', '', '', '');
        ccClosePanel(false);
      }
    }

    ccBuild();

    function onVariantChange() {
      var selectedOptions = getSelectedOptions();
      updateCustomColour();
      var variant = findVariant(selectedOptions);
      if (!variant) return;

      if (variantIdInput) variantIdInput.value = variant.id;
      updatePrice(variant);
      updateAddToCart(variant);
      updateInventory(variant);
      updateBackorder(variant);
      updatePickup(variant.id);

      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState({}, '', url.toString());

      if (variant.featured_media && galleryMain) {
        showGalleryMedia(variant.featured_media.id);
      }
    }

    if (variantPicker) {
      variantPicker.addEventListener('change', function (e) {
        if (e.target.tagName === 'INPUT' && e.target.type === 'radio') {
          onVariantChange();
        }
      });
    }

    function setActiveThumb(mediaId) {
      if (!thumbContainer) return;
      mediaId = String(mediaId);
      thumbContainer.querySelectorAll('.product-gallery__thumb').forEach(function (btn) {
        var active = btn.dataset.mediaId === mediaId;
        btn.classList.toggle('product-gallery__thumb--active', active);
        btn.setAttribute('aria-current', active ? 'true' : 'false');
      });
    }

    function showGalleryMedia(mediaId) {
      if (!galleryMain) return;
      mediaId = String(mediaId);
      if (galleryMobile.matches) {
        // Mobile: every slide is visible in a swipe carousel, so scroll to the chosen one.
        var target = galleryMain.querySelector('.product-gallery__slide[data-media-id="' + mediaId + '"]');
        if (target && target.scrollIntoView) {
          target.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }
      } else {
        // Desktop: reveal only the chosen slide.
        galleryMain.querySelectorAll('.product-gallery__slide').forEach(function (slide) {
          if (slide.dataset.mediaId === mediaId) {
            slide.classList.remove('product-gallery__slide--hidden');
          } else {
            slide.classList.add('product-gallery__slide--hidden');
          }
        });
      }
      setActiveThumb(mediaId);
    }

    // Mobile carousel: keep the active thumbnail in sync as the customer swipes.
    if (galleryMain) {
      var gScrollTimer;
      galleryMain.addEventListener('scroll', function () {
        if (!galleryMobile.matches) return;
        window.clearTimeout(gScrollTimer);
        gScrollTimer = window.setTimeout(function () {
          var center = galleryMain.scrollLeft + (galleryMain.clientWidth / 2);
          var nearest = null;
          var nearestDist = Infinity;
          galleryMain.querySelectorAll('.product-gallery__slide').forEach(function (slide) {
            var slideCenter = slide.offsetLeft + (slide.offsetWidth / 2);
            var dist = Math.abs(slideCenter - center);
            if (dist < nearestDist) {
              nearestDist = dist;
              nearest = slide;
            }
          });
          if (nearest) setActiveThumb(nearest.dataset.mediaId);
        }, 60);
      }, { passive: true });
    }

    if (thumbContainer) {
      var galleryHoverable = window.matchMedia('(hover: hover) and (pointer: fine)');

      thumbContainer.querySelectorAll('.product-gallery__thumb').forEach(function (btn) {
        btn.addEventListener('mouseenter', function () {
          if (galleryHoverable.matches) showGalleryMedia(btn.dataset.mediaId);
        });
      });

      thumbContainer.addEventListener('click', function (e) {
        var btn = e.target.closest('.product-gallery__thumb');
        if (!btn) return;
        showGalleryMedia(btn.dataset.mediaId);
      });

      thumbContainer.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          var btn = e.target.closest('.product-gallery__thumb');
          if (!btn) return;
          e.preventDefault();
          showGalleryMedia(btn.dataset.mediaId);
        }
      });
    }

    if (qtyInput) {
      var minus = section.querySelector('[data-qty="minus"]');
      var plus  = section.querySelector('[data-qty="plus"]');

      if (minus) {
        minus.addEventListener('click', function () {
          var val = parseInt(qtyInput.value, 10) || 1;
          if (val > 1) qtyInput.value = val - 1;
        });
      }

      if (plus) {
        plus.addEventListener('click', function () {
          var val = parseInt(qtyInput.value, 10) || 1;
          qtyInput.value = val + 1;
        });
      }
    }

    updateCustomColour();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
(function () {
  var sections = document.querySelectorAll('.product-recommendations[data-section-id]');
  sections.forEach(function (section) {
    if (section.dataset.fetched) return;
    section.dataset.fetched = 'true';

    var sectionId = section.dataset.sectionId;
    var productId = section.dataset.productId;
    var baseUrl = section.dataset.recommendationsUrl;
    var limit = section.dataset.limit || '4';

    if (!sectionId || !productId || !baseUrl) return;

    var url =
      baseUrl +
      '?section_id=' + encodeURIComponent(sectionId) +
      '&product_id=' + encodeURIComponent(productId) +
      '&limit=' + encodeURIComponent(limit) +
      '&intent=related';

    fetch(url)
      .then(function (response) {
        if (!response.ok) return;
        return response.text();
      })
      .then(function (html) {
        if (!html) return;
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var fetched = doc.querySelector('.product-recommendations');
        if (fetched && fetched.innerHTML.trim() !== '') {
          section.innerHTML = fetched.innerHTML;
        }
      })
      .catch(function () {});
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["used-cages"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-uc-card]').forEach(function (card) {
    var main = card.querySelector('[data-uc-main]');
    var thumbs = card.querySelectorAll('[data-uc-thumb]');
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var full = thumb.getAttribute('data-full');
        if (full) main.src = full;
        thumbs.forEach(function (t) { t.setAttribute('aria-current', t === thumb ? 'true' : 'false'); });
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vehicle-header"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-vehicle-change]').forEach(function (btn) {
    var panel = document.getElementById(btn.getAttribute('aria-controls'));
    if (!panel) return;
    btn.addEventListener('click', function () {
      var willOpen = panel.hidden;
      panel.hidden = !willOpen;
      btn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      if (willOpen) {
        var firstSelect = panel.querySelector('select');
        if (firstSelect) firstSelect.focus();
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
